import { zurich_data } from './cities_fr/zurich'
import { geneva_data } from './cities_fr/geneva'
import { basel_data } from './cities_fr/basel'
import { bern_data } from './cities_fr/bern'
import { lausanne_data } from './cities_fr/lausanne'

export const city_datas_fr: { [key: string]: CityData } = {
  zurich: zurich_data,
  geneva: geneva_data,
  basel: basel_data,
  bern: bern_data,
  lausanne: lausanne_data,
}

export function getCityData_fr(
  mob: boolean = false,
  dm: boolean = false,
  city: string = 'zurich'
): CityData {
  var desiredcity: CityData = city_datas_fr[city]

  desiredcity.elements.forEach((el) => {
    el.image = require('../Maps/maps_' +
      desiredcity.bfsid +
      '_' +
      el.image +
      (mob ? '_mob' : '') +
      (dm ? '_dm' : '') +
      '.jpg')
  })
  return desiredcity
}
